import React, { useEffect, useLayoutEffect, useMemo, useState, Suspense } from 'react';
import Styles from './index.module.scss';
import cn from 'classnames';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { isEmpty } from 'lodash';
import { TouchableButton, TouchableDiv } from '../common/Touchable/index';
import Loader from '@components/common/Loader/newLoaderModal';
import { CUSTOM_MESSAGES } from '@veriables';
import { getObjectValue } from '@utility/utills';
import { connect } from 'react-redux';

const createTable = ({
  type,
  maxLength,
  isAlpha,
  name,
  placeholder,
  onSubmit,
  isOpen,
  specialValue,
  buttonName,
  check,
  serverAppTheme,
  screenType,
  cancelBtnName,
  onCancel,
  setErrorPopUp,
  orderingPortraitOrientation,
}) => {
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [inputs, setInputs] = useState({
    [name]: specialValue,
  });
  const [inputName, setInputName] = useState(name);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [error, setError] = useState({});

  const closeKeyboard = () => {
    setSwipedDown(false);
  };
  // const deviceInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('deviceInfo'), false));

  const onClickBtn = e => {
    setError({});
    setSelectedSeats([]);
    const value =
      e === '{bksp}'
        ? { ...inputs, [inputName]: inputs[inputName]?.slice(0, -1) }
        : {
            ...inputs,
            [inputName]: inputs[inputName]
              ? inputs[inputName].concat(e)
              : ''.concat(e),
          };
    setInputs({
      ...inputs,
      [inputName]: value[inputName],
    });
  };
  useLayoutEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(type === 'number' ? 'number' : type );
    }
  }, [type]);

  useLayoutEffect(() => {
    setInputs({
      ...inputs,
      [name]: specialValue,
    });
  }, [isOpen]);

  const setEmpty = data => {
    setInputs({
      ...inputs,
      [data]: '',
      error: '',
    });
  };
  const getInputValue = inputNameDat => {
    return inputs[inputNameDat] || '';
  };

  const buttonTheme = {
    '{done}': {
      class: 'bgGreen',
    },
  };

  const submit = () => {
    onSubmit(selectedSeats.length > 0 ? selectedSeats : inputs[inputName]);
  };

  const validateSeatNumber = val => {
    if (selectedSeats.length > 0) {
      return submit();
    }
    const isSeat = JSON.parse(window.sessionStorage.getItem('seat')).seats.find(
      item => item.open && item.number === Number(val)
    );
    if (isEmpty(val)) {
      setError({
        ...error,
        seatNumber: `Select Seat ${name === 'seatName' ? 'Name' : 'Number'}`,
      });
    } else if (isSeat) {
      setErrorPopUp({
                    res: 'Seat number already taken',
                    noErrorTxt: true,
                });
    }
    return val && !isSeat && submit();
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const addRemoveSeats = node => {
    setError({ ...error, seatNumber: '' });
    if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
      setSelectedSeats([node]);
    } else if (
      selectedSeats.indexOf(node) === -1 &&
      !selectedSeats.includes('table')
    ) {
      setSelectedSeats(selectedSeats.concat(node));
    } else {
      setSelectedSeats(selectedSeats.filter(x => x !== node));
    }
    if (node === 'table') {
      setSelectedSeats(['table']);
    }
  };

const [finatSeatArray, setFinalSeatArray] = useState();
let seatArrays = [];
const addSeatDynamically = () => {
let count = 0;
let seatCount = 1;
  while(count < 16) {
    if(check?.seats?.filter((e) => e.open && e.number === seatCount).length === 0) {
      seatArrays[count] = seatCount;
      count++;
      seatCount++;
  } else {
      seatCount++;
  }
  }
  return seatArrays
}
useEffect(() => {
 let addedSeats = addSeatDynamically();
 setFinalSeatArray(addedSeats)
},[])

const keyboardStyle = useMemo(() => {
  const wrapperStyle = {
    margin: '1rem auto'
  }
  const buttonContainer = { bottom: !orderingPortraitOrientation ? '30px' : '12px', left:'0'}
  const submitButton = {
    backgroundColor: serverAppTheme?.secondaryBtn,
    color: serverAppTheme?.btn_font_color,
    height: !orderingPortraitOrientation ? '90%' : '',
  }
  const cancelButton = {
    color: serverAppTheme?.cancleBtn_font,
    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
    border: serverAppTheme?.cancleBtn_Border,
  }

  return { wrapperStyle, buttonContainer, submitButton, cancelButton }
}, [serverAppTheme, selectedSeats])

const handleAddSeatClick = () => {
  if(selectedSeats?.length === 0 && !inputs[inputName]){
    setErrorPopUp({
                    res: CUSTOM_MESSAGES().ADD_SEAT_ERROR,
                    noErrorTxt: true,
                    onClickChange: () => {},
                });
  } else {
    name === 'seatNumber'
    ? validateSeatNumber(getInputValue(name))
    : submit()
  }
}
  return (
    <>
    <div className={cn('col-12 px-0 pt-1 large-input  d-flex align-items-center justify-content-center  position-relative h-95')}>
      <div className='col-12 px-0 h-100 position-relative'>
        {check && (
          <div className={cn('col-12 px-0 w-100', !orderingPortraitOrientation ? 'h-18 pt-2' : 'h-43 mt-3')}>
            <div className={cn('col-12 row px-3 mx-0 my-0 flex-wrap w-100 pb-2', !orderingPortraitOrientation ? Styles.wrapper : Styles.wrapperPortrait)} style={keyboardStyle.wrapperStyle}>
              {finatSeatArray?.map(item => {
                return (
                    <TouchableDiv
                      key={item}
                      role="presentation"
                      onClick={() => {
                        addRemoveSeats(item);
                        setEmpty(name);
                      }}
                      className={cn(
                        Styles.btnBorderWhite,
                        selectedSeats.length > 0 && selectedSeats.includes(item)
                          ? Styles.selectedSeats
                          : `${Styles.unSelectedSeats}`,
                        'd-flex justify-content-center align-items-center border rounded w-100 fw-500', !orderingPortraitOrientation ? 'fs_16' : 'fs_20'
                      )}
                      style={{ color: selectedSeats?.includes(item) ? '#000' : serverAppTheme?.primary_text, border: selectedSeats?.includes(item) ? 'none' : serverAppTheme?.popupBorder, background: selectedSeats?.includes(item) ? serverAppTheme?.selected : serverAppTheme?.unselected, height: !orderingPortraitOrientation ? '2rem' : '5rem' }}
                    >
                      {item}
                    </TouchableDiv>
                );
              })}
            </div>
          </div>
        )}
        <div
          className={cn(
            'col-12 px-3 position-relative', error?.seatNumber?.length > 0 ? 'h-15 py-1' : !orderingPortraitOrientation ? 'h-17 py-2' : 'h-8 my-4'
          )}
        >
          <input
            id={name}
            type="text"
            name={name}
            className={cn('col-12 p-2 fs_18 fw-400 text-left h-100', Styles.inputFild)}
            style={{background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text }}
            placeholder={placeholder}
            value={getInputValue(name)}
            onFocus={() => {
              handleBlur();
              setInputName(name);
              setKeyboardType(type);
            }}
          />
        </div>
        {error?.seatNumber?.length > 0 && (
          <div className="error fs_12 text-right px-3">{error.seatNumber}</div>
        )}
        {isSwipedDown && (
          <div className={cn(!orderingPortraitOrientation ? '' : 'mx-3')}>
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={e => onClickBtn(e)}
              type={keyboardType}
              typed={inputs[inputName] || ''}
              closeKeyboard={closeKeyboard}
              // btnSize="btn"
              customClass={`fs-30 p-1 pl-2`}
              maxLength={maxLength}
              buttonTheme={buttonTheme}
              setinputEmpty={() => {
                setInputs({
                  ...inputs,
                  [inputName]: ''
                });
              }}
              screenType={screenType}
            />
          </div>
        )}
        <div style={keyboardStyle.buttonContainer} className={cn('col-12 px-3 d-flex justify-content-center align-items-center w-100 position-absolute', error?.seatNumber?.length > 0 && 'pt-1')}>
          <div className={cn('pl-0 pr-1 h-100 d-flex align-items-end', !orderingPortraitOrientation ? 'col-4' : 'col-6')}>
            <TouchableButton
              className={cn('w-100 btn-ripple rounded h-90', !orderingPortraitOrientation ? '' : 'btn68')}
              type="button"
              onClick={(e) => {onCancel(); e.preventDefault()}}
              style={keyboardStyle.cancelButton}
              rippleEffect={true}
            >
              <div className="fs_28 fw-600">{cancelBtnName}</div>
            </TouchableButton>
          </div>
          <div className={cn('pl-1 pr-0 h-100 d-flex align-items-end', !orderingPortraitOrientation ? 'col-4' : 'col-6')}>
            <TouchableButton
              className={cn('w-100 btn-ripple border-0 rounded', !orderingPortraitOrientation ? '' : 'btn68')}
              type="button"
              onClick={(e) =>  {handleAddSeatClick(); e.preventDefault()}}
              style={keyboardStyle.submitButton}
              rippleEffect={true}
            >
              <div className="fs_28 fw-600">{buttonName}</div>
            </TouchableButton>
          </div>
        </div>
      </div>
    </div>
          <Suspense fallback={<Loader />}>
            </Suspense>
  </>
  );
};

const mapStateToProps = ({orders}) => ({
  orderingPortraitOrientation: orders?.orderingPortraitOrientation,
})

export default connect(mapStateToProps)(createTable);
